<template>
  <div class="text-center text-danger my-2">
    <b-spinner small class="align-middle me-2"></b-spinner>
    <slot>
      <strong>Please Be Patient...</strong>
    </slot>
  </div>
</template>
